export async function getShortUrl(url) {
  const request = await (
    await fetch('https://benchmade-api.3kit.com/api/url-shortener', {
      method: 'POST',
      headers: {
        Authorization: `Static bq3mP8XFvgHSsp25dtc7RUBWQJaf9uYMZLwAKyCTzNVE4rGhD6`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        originalUrl: url,
      }),
    })
  ).json();

  return request.shortenUrl;
}

export async function postBenchmadeData(
  subtotal,
  shortId,
  mainSku,
  assetId,
  env,
) {
  const param = env === 'admin-fts' ? 'prod' : 'preview';
  const response = await fetch(
    `/apps/service/threekit/api/config/create?env=${param}`,
    {
      method: 'POST',
      body: JSON.stringify({
        price: subtotal,
        custom_knife: shortId,
        cart_item: 1,
        sku: mainSku,
        quantity: 1,
        asset_id: assetId,
        short_id: shortId,
        configuration: {},
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return response;
}

export async function getShortId(env, authToken, formData) {
  const { shortId } = await fetch(
    `https://${env}.threekit.com/api/configurations?bearer_token=${authToken}`,
    {
      method: 'POST',
      body: formData,
    },
  ).then((r) => r.json());

  return shortId;
}

export async function getThumbnailUrl(env, shortId, authToken) {
  const getThumbnail = await fetch(
    `https://${env}.threekit.com/api/configurations/${shortId}/thumbnail?bearer_token=${authToken}`,
  );

  return getThumbnail.url;
}

export async function getThreekitConfiguration(env, authToken, shortId) {
  const response = await fetch(
    `https://${env}.threekit.com/api/configurations/${shortId}?bearer_token=${authToken}`,
    {
      method: 'GET',
    },
  ).then((r) => r.json());

  return response.variant;
}
